export function renderTooltip(p) {
  let data = JSON.stringify(p);

  let address = p.clean_address;
  let [street_address, ...city_zip] = address.split(',');
  let status;
  let slug;
  if (p.is_retrofitted == 0) {
    slug = 'not_retrofitted';
    status = 'NOT RETROFITTED';
  } else if (p.is_retrofitted == 1) {
    slug = 'complete';
    status = 'RETROFIT COMPLETE';
  } else {
    slug = 'other';
    status = 'UNKNOWN RETROFIT STATUS';
  }
  // let slug = p.retrofit_status.replace(' ', '_').toLowerCase();

  let zone;

  if (p.is_liquefaction_zone == 'true' && p.is_fault_zone == 'true') {
    zone = 'This address is within a liquefaction zone.';
  } else if (p.is_liquefaction_zone == 'true') {
    zone = `This address is within a liquefaction zone and the ${p.fault_name} Zone.`;
  }

  let t = `<div class="tooltip ${slug}">
      <p class="tooltip-status">${status}</p>
      <h3 class="tooltip-title">${street_address}</h3>
      <h4 class="tooltip-subtitle">${city_zip}</h4>
    </div>`;

  return t;
}
